let scriptsAdded = false;

export function addRetargetingScripts() {
  if (scriptsAdded) return;

  // Prepare main container for scripts
  const mainContainer = document.getElementById("app");
  if (mainContainer !== null) {
    mainContainer.setAttribute("style", "overflow-x:hidden;");
  }

  const startTime = performance.now();

  // ExoClick
  const exoclickScript = document.createElement("script");
  exoclickScript.type = "application/javascript";
  exoclickScript.src = "https://a.exoclick.com/tag_gen.js";
  exoclickScript.setAttribute("data-goal", "a6074710358abe90ea81e3e5576f0087");
  document.body.appendChild(exoclickScript);

  // GoogleAds
  const googleadsScript = document.createElement("script");
  googleadsScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-1018861338";
  googleadsScript.async = true;
  document.head.appendChild(googleadsScript);
  // GoogleAds Tracking
  googleadsScript.addEventListener("load", () => {
    const googleadsTrackingScript = document.createElement("script");
    googleadsTrackingScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-1018861338');
      `;
    document.head.appendChild(googleadsTrackingScript);
  });

  // TrafficStars
  const trafficstarsScript = document.createElement("img");
  trafficstarsScript.src = "//tsyndicate.com/api/v1/retargeting/set/fae13064-a2be-40c4-881d-bead9a0e4166";
  trafficstarsScript.height = 1;
  trafficstarsScript.width = 1;
  document.body.appendChild(trafficstarsScript);

  // TrafficJunky

  const idsyncScript = document.createElement("script");
  idsyncScript.src = "https://hw-cdn2.adtng.com/delivery/idsync/idsync.min.js";
  idsyncScript.defer = true;
  document.head.appendChild(idsyncScript);

  idsyncScript.addEventListener("load", () => {
    const idsyncScriptRun = document.createElement("script");
    idsyncScriptRun.text = `
      window.idsync.config(34296) .fp_get() .sync();
      window.idsync.send_event({"name":"visited_lander","type":"Inquiry","value":"0.001"})
    `;
    document.head.appendChild(idsyncScriptRun);
  });

  scriptsAdded = true;
}
